import React, { useEffect, useState } from "react";
import { View } from "react-native";
import NewsletterSection from "./news-letter-section";
import DesktopFooter from "./desktop-footer";
import MobileFooter from "./mobile-footer";
import SocialLinks from "./social-links";
import apiHelpers from "../../utils/api-helpers";

const FooterMain = ({
  token,
  chargebee_billing_platform,
  locationInfo,
  userProfile,
}) => {
  const [footerData, setFooterData] = useState(null);

  const fetchFooterData = async () => {
    const response = await apiHelpers.apiRequest("/footer", {}, "GET", true);
    if (response.success) {
      setFooterData(response.data);
    }
  };

  useEffect(() => {
    fetchFooterData();
  }, []);

  if (!footerData) {
    return null;
  }

  return (
    <View>
      <NewsletterSection token={token} userInfo={userProfile} />
      <DesktopFooter
        footerData={footerData}
        token={token}
        userInfo={userProfile}
        chargebee_billing_platform={chargebee_billing_platform}
        locationInfo={locationInfo}
      />
      <MobileFooter footerData={footerData} />
      <SocialLinks footerData={footerData} />
    </View>
  );
};

export default FooterMain;
